// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.query.FindQueryTriggersRequest */
/* istanbul ignore next */
@GandalfModel
export class FindQueryTriggersRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.QueryTemplateCategory)
	@GandalfValidator({ notNull: { message: 'Template category is required.' } })
	@GandalfProperty({ designType: constants.QueryTemplateCategory, isRequired: true })
	templateCategory!: constants.QueryTemplateCategory;

}
